import { render, staticRenderFns } from "./ButtonUpload.vue?vue&type=template&id=6a7a4ed0"
import script from "./ButtonUpload.vue?vue&type=script&lang=js"
export * from "./ButtonUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports